export default "<mat-option [ngClass]=\"{ hide: !visible, show: visible }\" [value]=\"value\">\n  <ng-content></ng-content>\n</mat-option>\n";